export const websiteSectionSmallBreakpoint = 640 // 40rem
const websiteSectionContainerWidth = 1200
export const websiteSectionHorizontalPadding = 40
export const websiteSectionMobileHorizontalPadding = 20
export const websiteSectionVerticalPadding = 72
export const websiteSectionContainerMaxWidth =
  websiteSectionContainerWidth + websiteSectionHorizontalPadding * 2
